require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-49-assigning-multiple-tasks-at-once.json") })
        }
      }, "path---article-49-assigning-multiple-tasks-at-once");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-49-assigning-multiple-tasks-at-once!./.cache/json/article-49-assigning-multiple-tasks-at-once.json
// module id = 553
// module chunks = 231608221292675